<template>

    <FlashNotifications ref="flash" />
    
    Bookings
  
</template>

<script>
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"
import FlashNotifications from "controllers/vue_components/flash_toast"

export default {
    name: 'OrganizationBookings',
    props: [],
    mixins: [Constants, RequestMixin],
    components: {
        FlashNotifications
    },
    data() {
        return {

        };
    },
    methods: { },
    computed: { },
    watch: { },
    created() { }
};
</script>
